import React from 'react'
import { Link } from 'react-router-dom'

const ConcursoListadoProvisional = () => {
  const reconsideracionesForm = 'https://forms.gle/AXdzYo8NV8Fn6XWVA'
  const textoReconsideraciones = 'Llenar formulario ubicado en la parte inferior de esta sección los días <b>22 y 23 de octubre de 2026</b>.'
  const textoReconPosterior = 'Las respuestas a las reconsideraciones serán enviadas vía correo electrónico <b>hasta el 31 de octubre</b>, posterior a lo cual publicaremos el listado definitivo de ganadores.'

  return (
    <div className='page-section instructivos listado-provisional'>
        <section className='info-container' id='index'>
          {/* <p className='heading-p'></p> */}
          
          <div className='text-group-listado spaced-lg'>
            <div className='callout info mb-4'>
              <i class="bi bi-info-circle icon"></i>
              <p>Los resultados son temporales y podrían cambiar después del período de Reconsideraciones.</p>
            </div>

            <div className='info-group column'>
              <Link
                className='btn-baremo btn btn-primary link-button my-0'
                to="/concurso/listado-provisional-concurso"
              >
                Ver Listado
              </Link>
            </div>
          </div>
          
          <div className='info-group text-start w-100 mt-2'>
            <h3 className='page-subtitle'>Reconsideraciones</h3>

            {/* <p className='fw-semibold'>Modalidad Virtual</p> */}

            <div className='list-column mb-4' hidden>
              <p>» Lunes 26 de octubre</p>
              <p>» Martes 30 de octubre</p>
              <p>» Miércoles 31 de octubre</p>
            </div>

            <p className='ws-pw spaced-lg' dangerouslySetInnerHTML={{__html: textoReconsideraciones}} />

            <p className='ws-pw spaced-lg' dangerouslySetInnerHTML={{__html: textoReconPosterior}}/>

            <a 
              href={reconsideracionesForm} 
              target='blank'
              className='btn-baremo btn btn-primary link-button my-0'
            >
              Formulario de Reconsideraciones
            </a>
          </div>

          <div className='info-group list-column' hidden>
            <p className='name-p lead-name'>Dr. Freddy Pachano Arenas<br/>Director</p>
            <p className='name-p'>Dra. Jorymar Leal<br/>Secretaria Docente</p>
          </div>
        </section>
    </div>
  )
}

export { ConcursoListadoProvisional }